import {translate} from 'views/module';

// The status options are every Loom client status except ACTIVE and INACTIVE, which are clients
// and not leads. They include the Loom-only UNRESPONSIVE.
const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.searchString = {
    key: 'searchString',
    label: translate('loomLead.LoomLeadList.Filter.Search'),
    rank: 0,
    type: 'text',
    options: null,
    canBeEmpty: false,
  };

  filterOptions.status = {
    key: 'status',
    label: translate('loomLead.LoomLeadList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('loomLead.Status'))
        .filter(([key]) => key !== 'ACTIVE' && key !== 'INACTIVE')
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            rank: index + 1,
            key: key,
          };
          return acc;
        }, {
          ALL: {
            label: 'All',
            rank: 0,
            key: 'ALL',
          },
        }),
    canBeEmpty: false,
  };

  return filterOptions;
};

export {
  generateFilterOptions,
};
